import React from 'react'
import styled, { keyframes } from 'styled-components'
import { Row, Col } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";


class TabsPasos extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            tab: "1"
        }
    }

    render() {
        const TabContainer = styled.div`
            min-height: 400px;
            margin-top: 100px;
            @media (max-width:767px) {
                margin-top: 50px;
                padding: 0 20px;
            }
        `
        const TabSelectors = styled.div`
            display: flex;
        `

        const ColorAnimation = keyframes`
            0%  {border-color: #c1eb18;}
            10% {border-color: #65ff00;}
            20% {border-color: #c1eb18;}
            30% {border-color: #a166ab;}
            40% {border-color: #5073b8;}
            50% {border-color: #04e5e5;}
            60% {border-color: #07b39b;}
            70% {border-color: #65ff00;}
            80% {border-color: #5073b8;}
            90% {border-color: #1098ad;}
            100% {border-color: #c1eb18;}
        `
        const TabSelector = styled.button`
            color: #000;
            font-size: 34px;
            font-weight: bold;            
            background-color: transparent;
            border: none;
            margin: 0 50px 0 0;            
            animation: ${ColorAnimation} 10s infinite alternate;
            &:hover, &.active {
                animation: ${ColorAnimation} 10s infinite alternate;
            }
            &:focus {
                outline: none;
            }
            @media (max-width: 767px) {                
                margin: 0 5px 0 0;                
            }
        `

        const Heading2 = styled.h2`
            font-size: 50px;
            font-family: Oswald;
            color: #32a350;
            line-height: 35px;
            font-weight: 600;
            padding: 60px 0 40px 0;
            text-align: center;
            @media (max-width: 767px) {
                padding: 10px 0 0 0;              
            }
        `

        const Heading3 = styled.h3`
            
        `

        const HeadingX = styled.span`
            color: #000;
            font-size: 62px;
            -webkit-text-fill-color: transparent;
            background: var(--secondarGradientColor);
            -webkit-background-clip: text;            
            background: linear-gradient(to right, rgb(66, 133, 244), rgb(227, 65, 51)) padding-box text;
            margin: 0 100px 0 0;            
            transition: .5s;
            animation: ${ColorAnimation} 10s infinite alternate;
            &:hover, &.active {
                animation: ${ColorAnimation} 10s infinite alternate;
            }
            &:focus {
                outline: none;
            }
            @media (max-width: 767px) {
                font-size: 20px;                
            }
        `

        const Tabs = styled.div`
            margin-top: 20px;
        `

        const Fade = keyframes`
            0% {
                opacity: 0;
            }
            100% {
                opacity: 1;
            }
        `

        const Tab = styled.div`
            display: none;
            animation: ${Fade} 1s forwards;
        `

        const LeftCol = styled(Col)`
            display: flex;
            align-items: baseline;
            justify-content: center;
            @media (max-width: 500px) {
                margin-bottom: 50px;
            }
        `

        const ServiceSeparator = styled.div`
            height: 5px;
            width: 50px;
            background-color:#32a350;
            margin-top: 50px;
        `

        const ServiceList = styled.ul`
            padding: 0;
            margin: 11px 0 0 10px;
        `

        const Submit = styled.a`
            color: #4285f4 !important;
            cursor: pointer !important;            
            font-size: 20px;
            line-height: 1;
            margin: 30px 0 0 0;
            padding: 17px 26px;
            position: relative;
            letter-spacing: 0.02em;            
            
	        -webkit-transition: all 300ms linear 0ms;
	        -moz-transition: all 300ms linear 0ms;
	        -ms-transition: all 300ms linear 0ms;
            transition: all 300ms linear 0ms;
            display: inline-block;
            font-weight: 400;            
            text-transform: uppercase;          
            &:hover {              
                transform: translateX(-20%);
                text-decoration: none;
                color: #32a350 !important;	            
                box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .30);
	            -webkit-transform: translateY(-5px);
	            transform: translateY(-5px);              
            }            
        `

        const Text = styled.p`
            color: #000;
            font-size: 20px;
            font-family: Poppins;
            font-weight: 400;
            text-align: justify;
        `

        const Textp = styled.p`
            color: #000;
            font-size: 32px;
            font-family: Poppins;
            font-weight: 400;
            text-align: justify;
        `

        const ServiceListElement = styled.li`
        list-style: circle;
        color: #000;
        font-weight: 300;
        font-size: 18px;
        margin: 5px 5px;
        &::before {
            display: inline-block;
            content: '';
            border-radius: 15px;
            height: 15px;
            width: 15px;            
            position: relative;
            bottom: 2.5px;
            animation: ${ColorAnimation} 10s infinite alternate;
            }
        `

        const { data } = this.props;
        console.log(data)
        // Agregar verificación para asegurarse de que los datos están disponibles
        if (!data || !data.allPricesJson || !data.allPricesJson.nodes.length) {
            return <div>Loading...</div>;
        }

        const prices = data.allPricesJson.nodes[0].items;

        console.log(prices)

        return (
            <TabContainer>
                <TabSelectors>
                    <TabSelector className={this.state.tab === "1" ? "active" : ""} onClick={() => this.setState({ tab: "1" })}>
                        <HeadingX>SEO Backlinks &gt;</HeadingX>
                    </TabSelector>
                </TabSelectors>
                <Tabs>
                    <Tab style={{
                        display: this.state.tab === "1" ? "block" : "none"
                    }}>
                        <Row>
                            <LeftCol md={6}>
                                
                                    <GatsbyImage image={this.props.image} alt="Agencia SEO en Colombia" />
                                
                            </LeftCol>
                            <Col md={6}>
                                <Heading2>
                                    SEO
                                </Heading2>
                                <Text>
                                    Servicio de construcción de Backlinks SEO de sombrero blanco de alta autoridad.
                                </Text>
                                <Textp>
                                    $ {prices.find(x => x.name === 'back').price}/por pedido
                                </Textp>
                                <ServiceSeparator />
                                <ServiceList>
                                    <ServiceListElement>
                                        30 Backlinks White hat
                                    </ServiceListElement>
                                    <ServiceListElement>
                                        1 Url
                                    </ServiceListElement>
                                    <ServiceListElement>
                                        DA 81-99 (Domain Authority)
                                    </ServiceListElement>
                                    <ServiceListElement>
                                        Backlinks manuales
                                    </ServiceListElement>
                                    <ServiceListElement>
                                        Entrega en 30 días
                                    </ServiceListElement>
                                    <ServiceListElement>
                                        Informe
                                    </ServiceListElement>
                                </ServiceList>
                                <Heading3>
                                    <Submit href="https://vascosolutions.com/zc/cart.php?a=add&pid=9">
                                        Contratar
                                    </Submit>
                                </Heading3>
                            </Col>
                        </Row>
                    </Tab>
                </Tabs>
            </TabContainer>
        )
    }
}

const PrecioImagen = (props) => (
    <StaticQuery
      query={graphql`
        query {
          allPricesJson(filter: { page: { eq: "SEO" }, section: { eq: "planes" } }) {
            nodes {
              items {
                name
                price
              }
            }
          }
          file(relativePath: {eq: "seo-colombia.jpg"}) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 500
              )
            }
          }
        }
      `}
      render={(data) => {
        const image = getImage(data.file.childImageSharp.gatsbyImageData);
        return (
          <TabsPasos
            data={data}
            image={image}
            {...props}
          />
        );
      }}
    />
  );
  
  export default PrecioImagen;
